export const INSTAGRAM_SETTINGS_DOCUMENT_ID = 'instagram.settings'
